import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const ASSOCIATIONS_POST_REQUEST = 'POST_ASSOCIATIONS_REQUEST';
export const ASSOCIATIONS_POST_FAILURE = 'POST_ASSOCIATIONS_FAILURE';
export const ASSOCIATIONS_POST_SUCCESS = 'POST_ASSOCIATIONS_SUCCESS';

export const postAssociation = data => {
    return function(dispatch) {
        dispatch(postRequest());
        return axios(apiRequestOptions(apiPath.ASSOCIATIONS.POST, data))
            .then(transformHttpResponse)
            .then(response => dispatch(postSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postRequest = () => {
    return {type: ASSOCIATIONS_POST_REQUEST}
};

const postFailure = error => {
    return {type: ASSOCIATIONS_POST_FAILURE, error}
};

const postSuccess = association => {
    return {type: ASSOCIATIONS_POST_SUCCESS, association}
};